/**
 * Created by vhe on 7/25/2017.
 */
'use strict';
var giftCardBalanceController = /** @class */ (function () {
    /*@ngInject*/
    function giftCardBalanceController(CartService, $state) {
        var _this = this;
        this.CartService = CartService;
        this.state = $state;
        var isNewRequest = false;
        this.CartService._getCart(isNewRequest).then(function (response) {
            _this.giftCardTotal = response.data.response.giftCardTotal || 0;
            _this.subTotal = response.data.response.subTotal || 0;
            _this.appliedCredit = _this.giftCardTotal > _this.subTotal ? _this.subTotal : _this.giftCardTotal;
            _this.remainedCredit = (_this.giftCardTotal - _this.subTotal) > 0 ? (_this.giftCardTotal - _this.subTotal) : 0;
        });
    }
    return giftCardBalanceController;
}());
export default giftCardBalanceController;
//# sourceMappingURL=gift-card-balance.controller.js.map